export const helpers = {
	defaults: {
		exportblockConfig: {
			alignment: 'left',
			font_size: 14,
			image_width: null,
			totals: []
		},
		exportcell: {
			rowspan: 1,
			colspan: 1,
			block: null
		},
		exportcolumn: {
			field_select: true,
			header: '',
			value: null
		},
		fieldConfig: {
			current_selection: false,
			chips: false,
			hide_new_order: false,
			generate_new_only: false,
			read_only: false,
			prefix:'',
			suffix:'',
			icon:'',
			help_text:'',
			max_length:'',
			show_counter: false,
			show_size: false,
			container_width:'',
			multiselect: false,
			allow_custom: false,
			option_groups_boolean: false,
			option_groups: [],
			default: '',
			visibility: 'visible',
			format: null,
			cast: 'string',
			posttype: null
		},
		option: {
			editing: false
		},
		optionConfig: {
			option_group: '',
			white_text: false
		},
		reportConfig: {
			show_customer: false,
			show_product: false,
			height: null,
			width: 'lg6',
			style: 'card',
			dashboards: [],
			categoryGroups: {}
		},
		capabilities: {
			'Orders': { view: false, edit: false, delete: false, create: false },
			'Products': { view: false, edit: false, delete: false, create: false },
			'Product Prices': { view: false, edit: false, delete: false, create: false },
			'Customers': { view: false, edit: false, delete: false, create: false },
			'Customer Prices': { view: false, edit: false, delete: false, create: false },
			'Price Types': { view: false, edit: false, delete: false, create: false },
			'Purchase Orders': { view: false, edit: false, delete: false, create: false },
			'Fields': { view: false, excludes: [], options: 'fields', edit: false, delete: false, create: false },
			'Departments': { view: false, excludes: [], options: 'departments', edit: false, delete: false, create: false },
			'Exports': { view: false, excludes: [], options: 'exports', edit: false, delete: false, create: false },
			'Reports': { view: false, excludes: [], options: 'reports', edit: false, delete: false, create: false },
			'Team Settings': { view: false, edit: false }
		},
		theme: {
			dark: false,
			themes: {
				light: {
					primary: "#4CAF50",
					secondary: '#424242',
					accent: '#1976D2',
					success: '#4CAF50',
					info: '#2196F3',
					warning: '#ffc107',
					error: '#FF5252',
				},
				dark: {
					primary: "#ffa000",
					secondary: '#424242',
					accent: '#5c6bc0',
					success: '#7cb342',
					info: '#2196f3',
					warning: '#fb8c00',
					error: '#c62828',
				}
			}
		},
		themedarks: {
			light: {
				primary: true,
				secondary: true,
				accent: true,
				success: true,
				info: true,
				warning: true,
				error: true
			},
			dark: {
				primary: false,
				secondary: true,
				accent: true,
				success: true,
				info: true,
				warning: true,
				error: true
			}
		},
		value: {
			id: 'generated',
			fake: true,
			format: null,
			pricefield: false
		}
	},

	setDefault: function(type, object) {
		// if(this.defaults[type]){
		let value = (type === 'roles' ? this.setRole(object) : (type === 'fields' ? this.setField(object) : (type === 'exports' ? this.setExport(object) : (type === 'reports' ? this.setReport(object) : (this.defaults[type] ? Object.assign({}, this.defaults[type], object) : object)))));
		// }
		return value;
	},
	setDefaults: function(type, objects) {
		let values = [];
		for (let x = 0, object; object = objects[x]; x++){
			let value = this.setDefault(type, object);
			values.push(value);
		}
		return values;
	},
	setExport: function(exportobj){
		if(exportobj.pdfrows){
			for(let x = 0, row; row = exportobj.pdfrows[x]; x++){
				for(let y = 0, cell; cell = row.cells[y]; y++){
					exportobj.pdfrows[x].cells[y] = this.setDefault('exportcell', cell);
					if(cell.block && cell.block.configuration){
						exportobj.pdfrows[x].cells[y].block.configuration = this.setDefault('exportblockConfig', cell.block.configuration)
					}
				}
			}
		}
		if(exportobj.csvcolumns){
			for (let x = 0, column; column = exportobj.csvcolumns[x]; x++){
				exportobj.csvcolumns[x] = this.setDefault('exportcolumn', column);
			}
		}
		return exportobj
	},
	setField: function(fieldobj){
		fieldobj.configuration = this.setDefault('fieldConfig', fieldobj.configuration);
		if(fieldobj.fieldoptions.length){
			for(let x = 0, option; option = fieldobj.fieldoptions[x]; x++){
				fieldobj.fieldoptions[x] = this.setDefault('option', option);
				fieldobj.fieldoptions[x].configuration = this.setDefault('optionConfig', option.configuration);
			}
		}
		return fieldobj;
	},
	setReport: function(report){
		report.configuration = this.setDefault('reportConfig', report.configuration);
		return report;
	},
	setRole: function(role){
		role.capabilities = this.setCapabilities(role.capabilities);
		return role;
	},
	setCapabilities: function(capabilities){
		capabilities = this.setDefault('capabilities', capabilities);
		for(let group in capabilities)
			capabilities[group] = Object.assign({}, this.defaults.capabilities[group], capabilities[group]);
		return capabilities;
	},
	setOrder: function({ order, departments, loadType, fieldIds}){
		let defaultConfiguration = {};
		for (let x = 0, department; department = departments[x]; x++){
			defaultConfiguration['d' + department.id] = false;
			defaultConfiguration['h' + department.id] = [];
		}
		order.load_type = loadType;
		order.load_time = moment();
		order.configuration = Object.assign(defaultConfiguration, order.configuration);
		order = this.pushOrderValues(order, fieldIds);
		return order;
	},
	pushOrderValues: function(order, fieldIds){
		let orderprice = 0,
			defaultValue = Object.assign({ created_at: order.created_at, updated_at: order.updated_at}, this.defaults.value);
		for (let a = order.fieldvalues.length - 1; a >= 0; a--){
			if([fieldIds.customer, fieldIds.date, fieldIds.order_price].indexOf(order.fieldvalues[a].field_id) > -1)
				order.fieldvalues.splice(a, 1);
		}
		order.fieldvalues.push(Object.assign({}, defaultValue, { field_id: fieldIds.customer, value: order.customer_id.toString() }));
		order.fieldvalues.push(Object.assign({}, defaultValue, { field_id: fieldIds.date, value: order.date }));
		for (let x = 0, orderitem; orderitem = order.orderitems[x]; x++){
			let rowprice = parseFloat(orderitem.total);
			if(rowprice) orderprice = orderprice + rowprice;
			order.orderitems[x] = this.pushOrderitemValues({ orderitem, fieldIds });
		}
		order.fieldvalues.push(Object.assign({}, defaultValue, { field_id: fieldIds.order_price, value: +orderprice.toFixed(2), pricefield: true}));
		return order;
	},
	pushOrderitemValues: function({ orderitem, fieldIds }){
		let rowprice = parseFloat(orderitem.total),
			defaultValue = Object.assign({ created_at: orderitem.created_at, updated_at: orderitem.updated_at}, this.defaults.value);
		for (let b = orderitem.fieldvalues.length - 1; b >= 0; b--){
			if([fieldIds.product, fieldIds.price_type, fieldIds.price, fieldIds.total].indexOf(orderitem.fieldvalues[b].field_id) > -1)
				orderitem.fieldvalues.splice(b, 1);
		}
		orderitem.fieldvalues.push(Object.assign({}, defaultValue, { field_id: fieldIds.product, value: (orderitem.product_id ? orderitem.product_id.toString(): null) }));
		orderitem.fieldvalues.push(Object.assign({}, defaultValue, { field_id: fieldIds.price_type, value: (orderitem.pricetype_id ? orderitem.pricetype_id.toString() : null), pricefield: true }));
		orderitem.fieldvalues.push(Object.assign({}, defaultValue, { field_id: fieldIds.price, value: + (orderitem.price ? parseFloat(orderitem.price).toFixed(2) : null), pricefield: true }));
		orderitem.fieldvalues.push(Object.assign({}, defaultValue, { field_id: fieldIds.total, value: (rowprice ? +rowprice.toFixed(2) : null), pricefield: true }));
		return orderitem;
	}
};
